module.exports = "https://static.wmbcdn.com/uniweb/images/b13aa856d72a21fd2574ef5e069ea819.svg";